let sessionIdentity: string | undefined;
let sessionRevision = 0;

export const syncAuthSessionIdentity = (userId: string | undefined) => {
  if (sessionIdentity === userId) return;
  sessionIdentity = userId;
  sessionRevision += 1;
};

export const getAuthSessionRevision = () => sessionRevision;
